import { BaseComment } from '../../../../../../../models/base/base-comment';

export class MemberRecordComment extends BaseComment {
  public memberId!: string;
}
